<template>
  <div>
    <b-modal
      ref="modalAgrupada"
      :title="'Selecione as propostas que deseja enviar a notificação agrupada'"
      size="xl"
      no-close-on-backdrop
      :title-class="'font-modal'"
      :dialog-class="'alteracao-tamanho'"
      :modal-class="'center-modal'"
      @show="carregarPropostas"
      @hidden="fechadoModal"
    >
      <vue-good-table
        :columns="columns"
        :rows="rows"
        theme="view"
        max-height="300px"
        :fixed-header="true"
        :row-style-class="'style-dados'"
        style-class="vgt-table striped bordered"
      >
        <template
          slot="table-row"
          slot-scope="props"
        >
          <b-checkbox
            v-if="props.column.field === 'check'"
            v-model="props.row.check"
            :disabled="props.row.atual"
            :checked="props.row.atual"
            :class="[{ 'check-desabilitado': props.row.atual }]"
            @change="checkboxClicked(props.row)"
          />
          <div :class="[{ 'proposta-nao-aprovada': props.row.status === 7 }]">
            <span v-if="props.column.field === 'statusProposta'">
              {{ props.row.statusProposta }}
            </span>
            <span v-if="props.column.field === 'numeroProposta'">
              {{ props.row.numeroProposta }}
            </span>
            <span v-if="props.column.field === 'pessoa'">
              {{ props.row.pessoa.nome }}
            </span>
            <span v-if="props.column.field === 'emailPessoa'">
              {{ props.row.pessoa.email }}
            </span>
            <span v-if="props.column.field === 'valorTotalPropostaAuditar'">
              {{ props.row.valorTotalPropostaAuditar | converteValor }}
            </span>
            <span v-if="props.column.field === 'gerente'">
              {{ props.row.nomeGerente }}
            </span>
          </div>
        </template>
        <div slot="emptystate">
          Carregando...
        </div>
      </vue-good-table>

      <b-row
        class="mt-2"
        align-h="between"
      >
        <b-col cols="4">
          <span
            v-if="!todosSelecionados"
            class="selecao-todas"
            @click="selecionarTodas(true)"
          >
            Selecionar todas "Clique Aqui"
          </span>
          <span
            v-if="todosSelecionados"
            class="selecao-todas"
            @click="selecionarTodas(false)"
          >
            Limpar seleção "Clique Aqui"
          </span>
        </b-col>
        <b-col cols="auto">
          <span style="font-weight: bold;font-size:15px;">Propostas selecionadas: {{ totalSelecionado }}</span>
        </b-col>
      </b-row>

      <template #modal-footer>
        <b-btn
          variant="danger"
          size="sm"
          class="mr-50"
          @click="cancelar"
        >
          Cancelar
        </b-btn>
        <b-btn
          variant="success"
          size="sm"
          @click="enviarAgrupado"
        >
          Enviar propostas selecionadas
        </b-btn>
      </template>
    </b-modal>
    <tabela-propostas-selecionadas
      ref="propostasSelecionadas"
      :propostas-selecionadas="propostasSelecionadas"
      @enviar-propostas-agrupadas="enviar"
    />
  </div>
</template>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";

.style-dados {
  font-size: 14px;
}

.font-modal {
  font-size: 18px;
}

.alteracao-tamanho {
  width: 1400px !important;
}

.center-modal {
  display: flex !important;
  justify-content: center !important;
}

.check-desabilitado {
  opacity: 0.6;
}

.selecao-todas {
  text-decoration: underline;
  color: var(--primary);
  cursor: pointer;
}

.proposta-nao-aprovada {
  color: red;
}
</style>

<script>
import { mapActions } from 'vuex'
import { VueGoodTable } from 'vue-good-table'
import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'
import apiTemplateEmail from '@/app-modulo/comuns/templates-gerais/shared/components/services/api'

export default {
  name: 'PropostasAgrupadas',
  components: {
    VueGoodTable,
    TabelaPropostasSelecionadas: () => import('./TabelaPropostasSelecionadas.vue'),
  },
  props: {
    propostaId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      columns: [
        {
          label: 'Ação',
          field: 'check',
          thClass: 'style-dados',
          width: '70px',
          sortable: false,
        },
        {
          label: 'Status',
          field: 'statusProposta',
          thClass: 'style-dados',
          width: '180px',
        },
        {
          label: 'Número',
          field: 'numeroProposta',
          thClass: 'style-dados',
          width: '135px',
        },
        {
          label: 'Pessoa',
          field: 'pessoa',
          thClass: 'style-dados',
          width: '135px',
        },
        {
          label: 'E-mail pessoa',
          field: 'emailPessoa',
          thClass: 'style-dados',
          width: '200px',
        },
        {
          label: 'Valor (R$)',
          field: 'valorTotalPropostaAuditar',
          thClass: 'style-dados text-left',
          type: 'decimal',
          tdClass: 'text-left',
          width: '115px',
        },
        {
          label: 'Responsável',
          field: 'gerente',
          thClass: 'style-dados',
          width: '200px',
        },
      ],
      rows: [],
      propostasSelecionadas: [],
      isCarregando: false,
      todosSelecionados: false,
      msgSemtemplate: [],
    }
  },
  computed: {
    totalSelecionado() {
      return this.propostasSelecionadas.length
    },
  },
  methods: {
    ...mapActions('listas', [
      'mudarColunaCartaoEnvio',
      'atualizarPropostaColuna']),
    carregarPropostas() {
      this.isCarregando = true
      api.getPropostasParaAgrupamento(this.propostaId)
        .then(payload => {
          this.rows = payload.data
          this.isCarregando = false
          this.rows[0].check = true
          this.propostasSelecionadas.push(this.rows[0])
        })
        .catch(err => {
          this.isCarregando = false
          this.$erro(err.response.data.message || err.message)
          throw err
        })
    },
    cancelar() {
      this.$isLoading(false)
      this.$refs.modalAgrupada.hide()
    },
    fechadoModal() {
      this.propostasSelecionadas = []
      this.rows = []
      this.todosSelecionados = false
    },
    enviar() {
      this.$isLoading(true)
      api.notificarPropostasAgrupadas(this.propostasSelecionadas)
        .then(payload => {
          const cartoes = payload.data
          for (let index = 0; index < cartoes.length; index += 1) {
            const cartao = cartoes[index]
            if (cartao.statusPropostaAntiga === 1) {
              this.mudarColunaCartaoEnvio(cartao)
            } else {
              this.atualizarPropostaColuna({ colunaDe: 2, propostaCartao: cartao })
            }
          }
          this.$sucesso('Propostas enviadas com sucesso!')
          this.$emit('enviado')
          this.cancelar()
        })
        .catch(err => {
          this.$isLoading(false)
          this.$erro(err.response.data.message || err.message)
          throw err
        })
    },
    enviarAgrupado() {
      const propostasId = this.propostasSelecionadas.map(map => map.id)
      apiTemplateEmail.validaTemplates(propostasId).then(payload => {
        this.msgSemtemplate = [payload.data]
        if (this.msgSemtemplate[0] !== '') {
          this.$atencaoHtml('', `<strong>${this.msgSemtemplate} <br> as propostas não serão enviadas</strong>`, 'Ciente')
            .then(() => {
            })
        } else {
          // eslint-disable-next-line no-lonely-if
          if (this.propostasSelecionadas[0].status !== 1) {
            this.$refs.propostasSelecionadas.show()
          } else {
            this.$confirmarHtml('Deseja enviar a(s) proposta(s) selecionada(s) agora?', this.montaNumeroProposta(), 'question', 'danger')
              .then(result => {
                if (result.value) {
                  this.enviar()
                }
              })
          }
        }
      })
        .catch(err => {
          this.$erro(err)
        })
    },
    montaNumeroProposta() {
      if (this.propostasSelecionadas[0].status === 1) {
        return `${this.propostasSelecionadas.length} proposta(s) selecionada(s)`
      }
      let text = ''
      for (let index = 0; index < this.propostasSelecionadas.length; index += 1) {
        const element = this.propostasSelecionadas[index]
        if (element) {
          text += `<span style="text-align:left;">${element.numeroProposta}</span><br>`
        }
      }
      return text
    },
    checkboxClicked(prop) {
      if (!this.propostasSelecionadas.some(som => som.id === prop.id)) {
        this.propostasSelecionadas.push(prop)
        this.todosSelecionados = this.propostasSelecionadas.length === this.rows.length
      } else {
        const index = this.propostasSelecionadas.findIndex(find => find.id === prop.id)
        if (index > -1) {
          this.propostasSelecionadas.splice(index, 1)
        }
      }
    },
    selecionarTodas(value) {
      this.todosSelecionados = value
      this.linhas = []
      this.rows.forEach(element => {
        const e = element
        if (!e.atual) {
          e.check = value
        }
        this.linhas.push(e)
      })
      this.rows = this.linhas
      this.propostasSelecionadas = this.rows.filter(fil => fil.check)
    },
  },
}
</script>
